export enum NotificationSenders {
  ICS_WHATSAPP = 'IcsWhatsApp',
  ICS_SMS = 'IcsSms',
  ICS_RCS = 'IcsRcs'
}
